import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Select from "../../../../../../inputs/select/index.js";
import usePersonCounterSelect from "../../hooks/usePersonCounterSelect.js";
import * as S from "./styled.js";
const PersonCounterSelect = (props)=>{
    const { value , options , ageLabel ='' , selectedOptionIndex =0  } = props;
    const { handleOnChange  } = usePersonCounterSelect(props);
    const passangerAge = ageLabel.includes('#number#') ? ageLabel.replace('#number#', (selectedOptionIndex + 1).toString()) : `${ageLabel} ${selectedOptionIndex + 1}`;
    return /*#__PURE__*/ _jsxs(S.PersonCounter, {
        "data-testid": "PersonCounterSelect",
        $hasAgeLabel: value?.value != value?.label,
        className: "person-counter-select",
        children: [
            /*#__PURE__*/ _jsx(S.Label, {
                children: passangerAge
            }),
            /*#__PURE__*/ _jsx(Select, {
                value: value,
                options: options,
                menuVariant: "floating",
                onChange: handleOnChange
            })
        ]
    });
};
export default PersonCounterSelect;

//# sourceMappingURL=index.js.map